import { render, staticRenderFns } from "./AnamnesiEditPage.vue?vue&type=template&id=0896554f&scoped=true"
import script from "./AnamnesiEditPage.vue?vue&type=script&lang=js"
export * from "./AnamnesiEditPage.vue?vue&type=script&lang=js"
import style0 from "./AnamnesiEditPage.vue?vue&type=style&index=0&id=0896554f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0896554f",
  null
  
)

export default component.exports